import React, { useState } from 'react';
import { BRAND } from '../../../content/staticAssets';

const STORAGE_KEY = 'myorglab_site_auth';
const SITE_PASSWORD = 'Mic123';
/** Set false to publish the site without the maintenance gate. */
const GATE_ENABLED = false;
/**
 * Test-only: CI sets REACT_APP_E2E_BYPASS_GATE=true at build time so e2e tests
 * skip the gate. Defaults off; never set it for staging or production builds.
 */
export function isE2EBypassEnabled(env = process.env) {
  return env.REACT_APP_E2E_BYPASS_GATE === 'true';
}
export { GATE_ENABLED };
const E2E_BYPASS_GATE = isE2EBypassEnabled({
  REACT_APP_E2E_BYPASS_GATE: process.env.REACT_APP_E2E_BYPASS_GATE,
});

export default function SitePasswordGate({ children }) {
  const [authed, setAuthed] = useState(
    () => !GATE_ENABLED || E2E_BYPASS_GATE || sessionStorage.getItem(STORAGE_KEY) === '1',
  );
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (!GATE_ENABLED || E2E_BYPASS_GATE || authed) {
    return children;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === SITE_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, '1');
      setError('');
      setAuthed(true);
      return;
    }
    setError('Access code not recognized.');
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-12 bg-[linear-gradient(180deg,theme(colors.brand.50)_0%,theme(colors.surface.muted)_45%,theme(colors.surface.sunken)_100%)]"
    >
      <div className="w-full max-w-lg overflow-hidden rounded-2xl border border-ink-200 bg-white shadow-xl">
        <div className="border-b border-surface-sunken bg-white px-8 pb-6 pt-10 text-center">
          <img
            src={BRAND.logoFull}
            alt="MyOrgLab"
            className="mx-auto h-24 w-auto sm:h-28"
          />
        </div>

        <div className="px-8 py-8 text-center">
          <h1 className="text-3xl font-semibold tracking-tight text-navy sm:text-4xl">
            We&apos;ll be back soon
          </h1>
          <p className="mt-4 text-base leading-relaxed text-ink-600 sm:text-lg">
            MyOrgLab is down for maintenance while we refresh the site.
            Thanks for your patience, we&apos;re making things better.
          </p>

          <div className="mt-8 rounded-xl border border-ink-200 bg-surface-subtle p-6 text-left">
            <p className="text-xs font-medium uppercase tracking-wider text-brand-700">
              Team access
            </p>
            <form onSubmit={handleSubmit} className="mt-4">
              <label htmlFor="site-password" className="sr-only">
                Access code
              </label>
              <input
                id="site-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter access code"
                className="w-full rounded-lg border border-ink-300 bg-white px-4 py-2.5 text-sm text-ink-800 placeholder:text-ink-400 focus:border-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-700/25"
                autoComplete="current-password"
              />
              {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
              <button
                type="submit"
                className="mt-4 w-full rounded-lg bg-brand-700 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-brand-800"
              >
                Enter site
              </button>
            </form>
          </div>

          <p className="mt-8 text-sm text-ink-500">
            Questions? Contact us at{' '}
            <a
              href="mailto:info@myorglab.com"
              className="text-brand-700 underline underline-offset-2 hover:text-navy"
            >
              info@myorglab.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
